import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { t, translate } from 'react-switch-lang';
import { Link } from 'react-router-dom';
import './contactusform.scss';
import './ContactUsPaySimply.scss';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-unresolved
import { faMobileAlt, faWindow } from '@awesome.me/kit-299dd46f46/icons/classic/light';
import { hideContactError, SubmitContactUs, mailcheckValidate } from '../../../helperFunctions/SubmitContactUs';
import { event as ampEvent, event, logAmpEvent } from '../../../helperFunctions/Amplitude';
import { setScreenReaderAlert } from '../../../helperFunctions/Accessibility';
import RadioBuilder from './RadioBuilder';
import { performSearch } from '../../../components/algolia/AlgoliaUtils';
import RelevantFAQ from './RelevantFAQ';

function ContactUsPaySimply({ widgetMode, removeAccount }) {
  const { lang } = useSelector((state) => state);
  const emailRef = useRef();
  const descriptionRef = useRef();
  const transRef = useRef();
  const paySimplyErrorMessageRef = useRef();
  const [appId, setAppId] = useState('');
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);
  const [category, setCategory] = useState('');
  const [disable, setDisable] = useState(false);
  const [paymentOption, setPaymentOption] = useState('');
  const [isPayment, setIsPayment] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const DEFAULT_FORM_ERROR = {
    email: null,
    description: null,
    platform: null,
    paymentOption: null,
    transactionNumber: null,
    paySimplyErrorMessage: null,
  };

  const defaultFieldOptions = {
    textArea: false,
    dropdown: false,
    paymentStatus: false,
    resendReceipt: false,
    refundDialog: false,
    transactionNumber: false,
    paySimplyErrorMessage: false,
  };

  const [formError, setFormError] = useState(DEFAULT_FORM_ERROR);

  const [showFields, setShowFields] = useState(defaultFieldOptions);

  const [webActive, setWebActive] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);

  const [validateEmailOnChange, setValidateEmailOnChange] = useState(false);
  const [validateAppIdOnChange, setValidateAppIdOnChange] = useState(false);
  const [validateDescriptionOnChange, setValidateDescriptionOnChange] = useState(false);
  const [validateTransactionOnchange, setValidateTransactionOnChange] = useState(false);
  const [validatePaymentOptionOnChange, setValidatePaymentOptionOnChange] = useState(false);
  const [validateErrorMessageOnChange, setValidateErrorMessageOnChange] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [suggestedArticleAlertRead, setSuggestedArticleAlertRead] = useState(false);

  const [showEmailConfirm, setShowEmailConfirm] = useState(false);
  const [runMailCheck, setRunMailCheck] = useState(true);
  const [invalidEmailSuggestion, setInvalidEmailSuggestion] = useState(null);

  const isMobile = (window.location.href.includes('mobileapp') ? '?mobileapp' : '');

  function handleWebMobileClick(target) {
    setValidateAppIdOnChange(true);
    hideContactError('app_error_message');
    const isWebsite = target === 'PaySimply website';

    setAppId(target);
    setWebActive(isWebsite);
    setMobileActive(!isWebsite);
  }

  function handleShowFields(option) {
    hideContactError('category_error_message');
    setIsPayment(false);
    setCategory(option);
    switch (option) {
      case 'Payment Verification':
        setIsPayment(true);
        setSearchTerm('');
        setShowFields({
          ...defaultFieldOptions,
          paymentStatus: true,
        });
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_PaySimply_PaymentVerification')));
        break;
      case 'Payment Issue':
        setIsPayment(true);
        setShowFields({
          ...defaultFieldOptions,
          transactionNumber: true,
          textArea: true,
          paySimplyErrorMessage: true,
          dropdown: true,
        });
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_PaySimply_PaymentIssue')));
        break;
      case 'Missing Receipt':
        setSearchTerm('');
        setShowFields({
          ...defaultFieldOptions,
          resendReceipt: true,
        });
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_PaySimply_MissingReceipt')));
        break;
      case 'Other':
        setShowFields({
          ...defaultFieldOptions,
          textArea: true,
        });
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_PaymentOption_Other')));
        break;
      case 'Data or account deletion request':
        setShowFields({
          ...defaultFieldOptions,
          textArea: true,
        });
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('ContactForm_Category_All_AccountDeletion')));
        break;
      case 'Refund':
        setShowFields({
          ...defaultFieldOptions,
          refundDialog: true,
        });
        setScreenReaderAlert(t('ScreenReaderAlert_SelectedOption').replace('xOption', t('Contact_Paysimply_Category_Refund')));
        break;
      default:
        break;
    }
  }

  function validateEmail(value) {
    if (value.length > 50) return t('Validation_Length_Max').replace('xMax', '50');
    if (!/^[\w!#$%&*+/=?`{|}~^-‘’']+(?:\.[\w!#$%&*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,32}$/.test(value)) return t('Validation_Type_Email');
    return null;
  }

  function validateEmpty(value) {
    if (value.trim().length === 0) return t('Validation_Required');
    return null;
  }

  function validateMaxCharacter(value, characterLimit) {
    if (value.trim().length > characterLimit) return t('Validation_Length_Max').replace('xMax', characterLimit);
    return null;
  }

  function validateTransactionNumber(value) {
    if (!/^(?:\d{13})?$/.test(value.trim())) return t('Contact_Paysimply_InvalidTransactionNumber');
    return null;
  }

  function validateFormField(force) {
    const errors = { ...DEFAULT_FORM_ERROR };
    if ((validateEmailOnChange || force) && emailRef.current) {
      const { value } = emailRef.current;
      errors.email = validateEmpty(value) || validateEmail(value);

      if (errors.email === null) {
        setInvalidEmailSuggestion(mailcheckValidate(value));
        if (runMailCheck && invalidEmailSuggestion !== null) {
          setShowEmailConfirm(true);
          errors.email = t('Contact_EmailSuggestion').replace('xEmail', invalidEmailSuggestion);
        } else {
          setShowEmailConfirm(false);
        }
      } else {
        setShowEmailConfirm(false);
      }
    }

    if ((validateAppIdOnChange || force) && appId === '') errors.appId = t('Validation_Required');

    if (showFields.dropdown && (validatePaymentOptionOnChange || force)) {
      errors.paymentOption = ((paymentOption === '') ? t('Validation_Required') : null);
    }

    if ((validateTransactionOnchange || force) && transRef.current) {
      const { value } = transRef.current;
      errors.transactionNumber = validateMaxCharacter(value, 13) ||
       validateTransactionNumber(value);
    }

    if ((validateErrorMessageOnChange || force) && paySimplyErrorMessageRef.current) {
      const { value } = paySimplyErrorMessageRef.current;
      errors.paySimplyErrorMessage = validateMaxCharacter(value, 100);
    }

    if ((validateDescriptionOnChange || force) && descriptionRef.current) {
      const { value } = descriptionRef.current;
      errors.description = validateEmpty(value) || validateMaxCharacter(value, 1500);
    }

    setFormError(errors);
    return errors;
  }

  useEffect(() => {
    if (widgetMode) {
      document.getElementById('desktop-contact-us').style.padding = '0px';
    }
    if (removeAccount) {
      handleWebMobileClick('PaySimply mobile app');
      handleShowFields('Data or account deletion request');
    }
  }, []);

  useEffect(() => {
    async function updateSearchResults() {
      const results = await performSearch(searchTerm, 'paysimply', lang);
      if (results.length > 0) {
        setSuggestedArticleAlertRead(true);
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_Suggested_Article', null, lang));
      } else if (suggestedArticleAlertRead) {
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_No_Suggested_Article', null, lang));
      }
      setSearchResults(results);
    }
    const timer = setTimeout(updateSearchResults, 700);
    return () => { clearTimeout(timer); };
  }, [searchTerm, lang]);

  useEffect(() => {
    const blockLocation = (widgetMode ? 'center' : 'start');

    if (submitted) {
      const errorField = document.querySelector('.is-invalid');
      if (errorField) {
        const group = errorField.closest('.form-groups');
        if (group) {
          group.scrollIntoView({ behavior: 'smooth', block: blockLocation });
          const input = group.querySelector('input, textarea, select');
          setTimeout(() => {
            input?.focus();
          }, 250);
        } else {
          errorField.scrollIntoView({ behavior: 'smooth', block: blockLocation });
          errorField.focus();
        }
      }
      setSubmitted(false);
    }
  });

  function sendAPI() {
    const data = {
      BrandID: appId,
      CustomerEmail: emailRef.current.value,
      Language: lang,
      Category: category,
      Body: descriptionRef.current.value,
    };
    if (isPayment) {
      data.PaymentOption = paymentOption;
    }

    if (showFields.transactionNumber && transRef?.current?.value) {
      data.transactionNumber = transRef.current.value;
    }

    if (showFields.paySimplyErrorMessage && paySimplyErrorMessageRef?.current?.value) {
      data.errorMessage = paySimplyErrorMessageRef.current.value;
    }

    const sending = document.getElementById('submit-button');
    sending.innerHTML = t('ContactForm_Submitting');
    setDisable(true);

    SubmitContactUs(data).then(
      () => {
        setShow(false);
        document.getElementById('desktop-contact-us').style.visibility = 'hidden';
        document.getElementById('successMessage').style.visibility = 'visible';
        document.getElementById('successMessage').style.display = 'block';
        const focus = document.getElementById('successMessage');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      () => {
        setError(t('Error_Something_Went_Wrong'));
        setShow(true);
        sending.innerHTML = t('ContactForm_Submit_button');
        setDisable(false);
        const focus = document.getElementById('error_message');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    );
  }

  function handleSubmit(e) {
    e.preventDefault();

    setValidateDescriptionOnChange(true);
    setValidateEmailOnChange(true);
    setValidatePaymentOptionOnChange(true);
    setValidateAppIdOnChange(true);
    setValidateTransactionOnChange(true);
    setValidateErrorMessageOnChange(true);

    const errors = validateFormField(true);
    if (!Object.values(errors).some((err) => err !== null)) {
      sendAPI();
      setScreenReaderAlert(t('ScreenReader_ContactForm_Success'));
    } else {
      setScreenReaderAlert(t('ScreenReader_ContactForm_Error'));
      setSubmitted(true);
    }
  }

  const handleTextareaChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      {show && (
        <Alert
          variant="danger"
          id="error_message"
          className="mt-3"
          onClose={() => {
            setShow(false);
            setError('');
          }}
          dismissible
        >
          <p style={{ marginBottom: 0 }}>{error}</p>
        </Alert>
      )}
      <div id="successMessage">
        <h1>{t('ContactForm_Submitted')}</h1>
        <Link to={(widgetMode) ? `/widget/paysimply/${lang}${isMobile}` : `/paysimply/${lang}/categories`}>
          <Button className="error-go-home-btn paysimply-button">{t('ReturnHome_Btn')}</Button>
        </Link>
      </div>
      <div id="desktop-contact-us">
        <div id="skip-link-content">
          <h1>{t('General_Contact_Us')}</h1>
          <p className="contact-label-suggestion">{t('ContactForm_Fields_Required')}</p>
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_Email_"
              required
            >
              <fieldset>
                <Form.Label as="legend" id="aria-email" className="form-labels">
                  {t('ContactForm_General_Email_Label')}
                </Form.Label>
                <Form.Text className="muted helpText">
                  {t('ContactForm_General_Email_Help')}
                </Form.Text>
                <Form.Control
                  aria-labelledby="aria-email aria-email-warn"
                  ref={emailRef}
                  className={`email-attr ${formError.email ? 'is-invalid' : ''}`}
                  onChange={() => {
                    if (validateEmailOnChange) validateFormField();
                    setRunMailCheck(true);
                  }}
                  onBlur={() => {
                    setValidateEmailOnChange(true);
                    validateFormField();
                  }}
                />
                <div className="invalidEmailContainer">
                  <span className="errorMessage">{formError.email}</span>
                  {showEmailConfirm && (
                    <div>
                      <Button
                        text={t('AccountDetails_MailCheck_ButtonYes')}
                        fill="outline"
                        className="mailCheckButton clickable-btn inactive-btn"
                        aria-label={t('Contact_EmailSuggestionYes').replace('xEmail', invalidEmailSuggestion)}
                        onClick={() => {
                          setRunMailCheck(false);
                          emailRef.current.value = invalidEmailSuggestion;
                          formError.email = null;
                          setInvalidEmailSuggestion(null);
                          setShowEmailConfirm(false);
                        }}
                      >
                        {t('Yes_Text')}
                      </Button>
                      <Button
                        text={t('AccountDetails_MailCheck_ButtonNo')}
                        fill="outline"
                        className="mailCheckButton clickable-btn inactive-btn"
                        aria-label={t('Contact_EmailSuggestionNo')}
                        onClick={() => {
                          setShowEmailConfirm(false);
                          setRunMailCheck(false);
                          formError.email = null;
                        }}
                      >
                        {t('No_Text')}
                      </Button>
                    </div>
                  )}

                </div>
              </fieldset>
            </Form.Group>

            <Form.Group
              className="form-inline"
              controlId="ContactForm_AppID_"
              required
            >
              <fieldset>
                <Form.Label id="app_label" as="legend" className={`form-labels ${formError.appId ? 'is-invalid' : ''}`}>
                  {t('ContactForm_General_AppID_Label')}
                </Form.Label>
                <div className="web-mobile-btn">
                  <Form.Check>
                    <Button
                      className={`clickable-btn ${
                        mobileActive ? 'active-btn' : 'inactive-btn'
                      }`}
                      id="contact-mobile-btn"
                      name="ContactForm_AppID_"
                      onClick={() => {
                        handleWebMobileClick('PaySimply mobile app');
                      }}
                    >
                      <FontAwesomeIcon icon={faMobileAlt} className="btn-icon" />
                      {t('ContactForm_AppID_Mobile')}
                    </Button>
                  </Form.Check>

                  <Form.Check>
                    <Button
                      className={`clickable-btn ${
                        webActive ? 'active-btn' : 'inactive-btn'
                      }`}
                      id="contact-web-btn"
                      name="ContactForm_AppID_"
                      onClick={() => {
                        handleWebMobileClick('PaySimply website');
                      }}
                    >
                      <FontAwesomeIcon icon={faWindow} className="btn-icon" />
                      {t('ContactForm_AppID_Website')}
                    </Button>
                  </Form.Check>
                </div>
                <Form.Text
                  id="app_error_message"
                  className="errorMessage"
                >
                  {formError.appId}
                </Form.Text>

              </fieldset>
            </Form.Group>

            {/* Which app did you use? */}
            <fieldset className="paysimply-radio">
              <Form.Label id="category_label" as="legend" className="form-labels">
                {t('ContactForm_General_Category_Label')}
              </Form.Label>

              <RadioBuilder
                value="Payment Verification"
                content={(
                  <>
                    {t('ContactForm_Category_PaySimply_PaymentVerification')}
                    <div style={{ fontSize: 'smaller' }}>
                      {t('ContactForm_Category_PaySimply_PaymentVerification_Deets')}
                    </div>
                  </>
                )}
                clickHandler={handleShowFields}
              />

              <RadioBuilder
                value="Payment Issue"
                content={t('ContactForm_Category_PaySimply_PaymentIssue')}
                clickHandler={handleShowFields}
              />
              <RadioBuilder
                value="Missing Receipt"
                content={(
                  <>
                    {t('ContactForm_Category_PaySimply_MissingReceipt')}
                    <div style={{ fontSize: 'smaller' }}>
                      {t('ContactForm_Category_PaySimply_MissingReceipt_Deets')}
                    </div>
                  </>
                )}
                clickHandler={handleShowFields}
              />

              <RadioBuilder
                value="Refund"
                content={t('Contact_Paysimply_Category_Refund')}
                clickHandler={handleShowFields}
              />

              <RadioBuilder
                value="Data or account deletion request"
                content={t('ContactForm_Category_All_AccountDeletion')}
                selected={removeAccount}
                clickHandler={handleShowFields}
              />

              <RadioBuilder
                value="Other"
                content={t('ContactForm_PaymentOption_Other')}
                clickHandler={handleShowFields}
              />
            </fieldset>

            {/* Check your payment status online */}
            {showFields.paymentStatus && (
              <div className="div-check-status">
                <div id="status-top">
                  <span>{t('Contact_Paysimply_CheckStatusOnlineTitle')}</span>
                  <span>{t('Contact_Paysimply_CheckStatusOnlineText')}</span>
                </div>
                <div id="status-bottom">
                  <a
                    href={t('Link_PaySimply_MyPayment')}
                    target="_blank"
                    rel="noreferrer"
                    className="paysimply-button btn"
                    aria-label={t('Contact_Paysimply_CheckStatusOnlineBtnCheckPayStatus')}
                    onClick={
                    () => {
                      logAmpEvent(ampEvent.USER_CLICKED_CHECK_PAYMENT_STATUS);
                    }
                  }
                  >
                    {t('Contact_Paysimply_CheckStatusOnlineBtnCheckPayStatus')}
                  </a>
                </div>
              </div>
            )}

            {/* Refund Dialog */}
            {showFields.refundDialog && (
            <div className="div-check-status">
              <div id="status-top">
                <span>{t('Contact_Paysimply_RefundDialogTitle')}</span>
                <span dangerouslySetInnerHTML={{ __html: t('Contact_Paysimply_RefundDialogContent') }} />
              </div>
            </div>
            )}

            {/* Payment option dropdown */}
            {showFields.dropdown && (
            <Form.Group
              className="form-groups"
              controlId="ContactForm_PaymentOption_"
            >
              <fieldset>
                <Form.Label
                  id="option_label"
                  as="legend"
                  className="form-labels"
                >
                  {t('ContactForm_General_PaymentOption_Label')}
                </Form.Label>

                {/* Dropdown */}
                <select
                  className={`custom-select ${formError.paymentOption ? 'is-invalid' : ''}`}
                  id="payment-option"
                  onBlur={() => setValidatePaymentOptionOnChange(true)}
                  onChange={() => {
                    const currentVal = document.getElementById('payment-option').value;
                    logAmpEvent(event.USER_SELECTED_PAYMENT_OPTION_USED, { 'Payment Option': currentVal });
                    setPaymentOption(currentVal);
                    if (validatePaymentOptionOnChange) validateFormField();
                  }}
                >
                  {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                  <option defaultValue="" />
                  <option value="Credit or Debit Card">{t('ContactForm_PaymentOption_CreditOrDebit')}</option>
                  <option value="Interac eTransfer">{t('ContactForm_PaymentOption_eTransfer')}</option>
                  <option value="PayPal">{t('ContactForm_PaymentOption_PayPal')}</option>
                  <option value="In person at Canada Post">{t('ContactForm_PaymentOption_InPerson')}</option>
                  <option value="Other">
                    {' '}
                    {t('ContactForm_PaymentOption_Other')}
                    {' '}
                  </option>
                </select>
              </fieldset>

              <Form.Text
                id="paymentOption_error_message"
                className="errorMessage"
              >
                {formError.paymentOption}
              </Form.Text>
            </Form.Group>
            )}

            {/* Re-send receipt */}
            {showFields.resendReceipt && (
              <div className="div-check-status">
                <div id="status-top">
                  <span>{t('Contact_PaySimply_ResendReceiptTitle')}</span>
                  <span>{t('Contact_PaySimply_ResendReceiptText')}</span>
                </div>
                <div id="status-bottom">
                  <a
                    href={t('Link_PaySimply_MyPayment')}
                    target="_blank"
                    rel="noreferrer"
                    className="paysimply-button btn"
                    aria-label={t('Contact_PaySimply_ResendReceipt_LinkDescription')}
                    onClick={
                    () => {
                      logAmpEvent(ampEvent.USER_CLICKED_GET_YOUR_RECEIPT);
                    }
                  }
                  >
                    {t('Contact_Paysimply_ResendReceiptBtnTitle')}
                  </a>
                </div>
              </div>
            )}

            {showFields.transactionNumber && (
              <Form.Group
                className="form-groups"
                controlId="ContactForm_General_TransactionNumber_"
                required
              >
                <fieldset>
                  <Form.Label as="legend" id="aria-transactionNumber" className="form-labels">
                    {t('Contact_Paysimply_TransactionNumberTitle')}
                  </Form.Label>
                  <Form.Text className="muted transactionNumber-help helpText">
                    {`(${t('ContactForm_Optional')}) ${t('Contact_Paysimply_SuccessPaymentHelpText')}`}
                  </Form.Text>
                  <Form.Control
                    aria-labelledby="aria-transactionNumber aria-transactionNumber-warn"
                    ref={transRef}
                    className={`transactionNumber-attr ${formError.transactionNumber ? 'is-invalid' : ''}`}
                    maxLength={13}
                    onBlur={() => {
                      setValidateTransactionOnChange(true);
                    }}
                    onChange={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, '');
                      if (validateTransactionOnchange) validateFormField();
                    }}
                  />
                  <Form.Text className="errorMessage">
                    {formError.transactionNumber}
                  </Form.Text>

                </fieldset>
              </Form.Group>

            )}

            {showFields.paySimplyErrorMessage && (
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_ErrorMessage_"
              required
            >
              <fieldset>
                <Form.Label as="legend" id="paySimplyErrorMessage" className="form-labels">
                  {t('Contact_Paysimply_ErrorMessageOnPaySimply')}
                </Form.Label>
                <Form.Text className="muted paySimplyErrorMessage-help helpText">
                  {`(${t('ContactForm_Optional')}) ${t('Contact_Paysimply_ErrorMessageOnPaySimplyHelpText')}`}
                </Form.Text>
                <Form.Control
                  aria-labelledby="errorMessage"
                  ref={paySimplyErrorMessageRef}
                  className={`paySimplyErrorMessage-attr ${formError.paySimplyErrorMessage ? 'is-invalid' : ''}`}
                  onBlur={() => {
                    setValidateErrorMessageOnChange(true);
                  }}
                  onChange={() => {
                    if (validateErrorMessageOnChange) validateFormField();
                  }}
                />
                <Form.Text className="errorMessage">
                  {formError.paySimplyErrorMessage}
                </Form.Text>
              </fieldset>
            </Form.Group>

            )}

            {/* How can we help */}
            {showFields.textArea && (
            <>
              <Form.Group
                className="form-groups"
                controlId="ContactForm_General_Body_"
                required
              >
                <fieldset>
                  <Form.Label as="legend" id="aria-desc" className="form-labels">
                    {t('ContactForm_General_Body_Label')}
                  </Form.Label>

                  <Form.Control
                    // onClick={()=>{logAmpEvent(event.USER_CLICK_CONTACT_TEXTBOX)}}
                    aria-labelledby="aria-desc"
                    as="textarea"
                    rows={8}
                    ref={descriptionRef}
                    className={`description-attr ${formError.description ? 'is-invalid' : ''}`}
                    onBlur={() => setValidateDescriptionOnChange(true)}
                    onChange={(e) => {
                      handleTextareaChange(e);
                      if (validateDescriptionOnChange) validateFormField();
                    }}
                  />
                  <Form.Text
                    className="errorMessage"
                  >
                    {formError.description}
                  </Form.Text>
                </fieldset>
              </Form.Group>
              <RelevantFAQ searchResults={searchResults} brand="paysimply" lang={lang} />
              <Button
                id="submit-button"
                className="paysimply-button"
                type="submit"
                disabled={disable}
                size="lg"
                style={{ backgroundColor: '#2B4E7B' }}
              >
                {t('ContactForm_Submit_button')}
              </Button>
            </>
            )}

          </Form>
          <Alert className="mt-3 email-banner" show={process.env.REACT_APP_ENV === 'dev'}>
            On the test system, contact form emails will be sent to
            <strong> psidevstar@gmail.com</strong>
          </Alert>
        </div>
      </div>
    </>
  );
}

export default translate(ContactUsPaySimply);
